import React,{Component} from 'react';
import Slider from "react-slick";

const categoryList = [
    {   
        imageUrl: 'img-10.png',
        name: 'Meal',
    },
    {   
        imageUrl: 'img-11.png',
        name: 'Meat',
    },
    {   
        imageUrl: 'img-12.png',
        name: 'Vegi',
    },
    {   
        imageUrl: 'img-13.png',
        name: 'Flower',
    },
    {   
        imageUrl: 'img-14.png',
        name: 'Drinks',
    },
    {   
        imageUrl: 'img-15.png',
        name: 'Fresh',
    },
    {   
        imageUrl: 'img-16.png',
        name: 'Frozen',
    },
    {   
        imageUrl: 'img-17.png',
        name: 'Wine',
    },
    {   
        imageUrl: 'img-18.png',
        name: 'Barkery',
    },
    {   
        imageUrl: 'img-19.png',
        name: 'Organic',
    },
    {   
        imageUrl: 'img-14.png',
        name: 'Beer',
    },
    {   
        imageUrl: 'img-12.png',
        name: 'Vegi',
    },
    
]

class Catagorysldiertwo extends Component {
    render() {
        const storysettings = {
            arrows: true,
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            centerMode: false,
            variableWidth: true
        };
        return (
            <Slider {...storysettings} className="slick-arrow-top">
                {categoryList.map((value , index) => (
                    <div key={index} className="me-1">
                        <div className="category-card style-three shadow-none text-center bg-transparent border-0">
                            <a href="/g-6" className="rounded-circle image-round"><img src={`assets/images/${value.imageUrl}`} className="w-85" alt="category" /></a>
                            <h4 className="font-xssss text-grey-900 mt-0 fw-700 d-block">{value.name}</h4>
                        </div>
                    </div>
                ))}
            </Slider>
        );
    }
}

export default Catagorysldiertwo;